import React, { ChangeEvent } from 'react';

type CheckboxProps = {
  id?: string;
  name?: string;
  value?: string;
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  style?: React.CSSProperties;
};

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  name,
  value,
  checked,
  onChange,
  className = '',
  style = {},
}) => {
  const defaultColor = '#414149';
  const checkedColor = style.color || defaultColor;

  return (
    <input
      type='checkbox'
      id={id}
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      className={`cursor-pointer ${className}`}
      style={{
        width: style.width || '20px',
        height: style.height || '20px',
        accentColor: checked ? checkedColor : defaultColor,
        ...style,
      }}
    />
  );
};

export default Checkbox;
